import {Chat} from "@web-libs/features/chat/domain/types/chat.type";
import {findMessageByInternalReferenceId} from "@web-libs/features/chat/domain/chatroom.functions";
import {addMessages, findChatroom} from "@web-libs/features/chat/domain/chat.functions";
import {SetChatFunction} from "@web-libs/features/chat/application/messenger/use-chat-messenger";

export const setPendingTimeout = (dispatch: SetChatFunction, chatroomId:string, internalReferenceId:string) => {
    setTimeout(() => {
        dispatch((currentChat: Chat) => {
            const chatMessage = findMessageByInternalReferenceId(findChatroom(currentChat,chatroomId), internalReferenceId)
            if(chatMessage && chatMessage.deliveryStatus === "pending") {
                return addMessages(currentChat, chatroomId, [{
                    ...chatMessage,
                    deliveryStatus: "failed"
                }])
            }
            return currentChat;
        })
    }, 10000)
}
